var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.965,
    height: 57.965,
    viewBox: "0 0 57.965 57.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.693 15.258)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.125,24.986V20.5a9.873,9.873,0,0,1,19.746,0v4.488",
    transform: "translate(3.031 -10.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.125,20.625a15.375,15.375,0,0,0,19.746,0",
    transform: "translate(3.031 -6.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.125,18.125a15.375,15.375,0,0,0,19.746,0",
    transform: "translate(3.031 -7.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.038,20.937a.063.063,0,0,1,.054,0h.072l10.771-1.562",
    transform: "translate(-1.368 -6.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.728,30.083c-.637,0-1.337.063-2.082.063A11.206,11.206,0,0,1,1.875,21.466a4.64,4.64,0,0,1,1.714-.539c6.364-.907,15.267,12.808,32.393,12.808,15.258,0,17.951-12.566,17.951-12.566l-12.566-1.8",
    transform: "translate(-1.875 -6.809)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 57.965,
    height: 57.965
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/Hat.707556a81ee55d8015ee034f33580fa9.svg";
export { ForwardRef as ReactComponent };